import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface HeapFrameNavigationProps {
  currentIndex: number;
  totalCount: number;
  onPrevious: () => void;
  onNext: () => void;
}

export function HeapFrameNavigation({
  currentIndex,
  totalCount,
  onPrevious,
  onNext,
}: HeapFrameNavigationProps): ReactElement {
  const { t } = useTranslation();

  return (
    <Box display='flex' alignItems='center' gap={0.5} flexShrink={0}>
      <IconButton onClick={onPrevious} disabled={currentIndex <= 0} aria-label={t('common.previous')}>
        <ChevronLeft fontSize='medium' />
      </IconButton>

      <Typography variant='body1' color='text.secondary' whiteSpace='nowrap'>
        {`${currentIndex + 1} / ${totalCount}`}
      </Typography>

      <IconButton onClick={onNext} disabled={currentIndex >= totalCount - 1} aria-label={t('common.next')}>
        <ChevronRight fontSize='medium' />
      </IconButton>
    </Box>
  );
}
